import { Toaster } from '@sea-snag/ui';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';

import { AuthSocketManager } from '../components/auth-socket-manager';
import { ErrorBoundary } from '../components/error-boundary';
import { AuthProvider } from '../contexts/auth-context';
import { OrganizationProvider } from '../contexts/organization-context';
import { SocketProvider } from '../contexts/socket-context';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <OrganizationProvider>
          <SocketProvider autoConnect={false}>
            <AuthSocketManager />
            <Outlet />
            <Toaster />
            {import.meta.env.DEV && <TanStackRouterDevtools position="bottom-right" />}
          </SocketProvider>
        </OrganizationProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}
